import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMaasComponent } from './simple-icons-maas.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMaasComponent ],
    exports:      [ SimpleIconsMaasComponent ],
    bootstrap:    []
})
export class SimpleIconsMaasModule {}
